import { ref } from 'vue'
import { useToast } from '@/composables/common/useToast'
import store from '@/store'
import { config } from '@/config.js'

export function useDeportistaIndumentarias(props, refreshBase) {
    const toast = useToast()

    // ==================== STATE ====================
    const showCambiarTallaModal = ref(false)

    /**
     * Asignar/agregar una indumentaria al deportista
     */
    async function addIndumentaria(data) {
        const params = {
            base_id: props.base_id,
            lista_id: props.lista_id,
            ...data
        }

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.indumentaria_base.update'),
                params
            )
            toast.success(res.data.message || 'Indumentaria asignada correctamente')
            await refreshBase()
        } catch (error) {
            console.error('Error adding indumentaria:', error)
            toast.error(error.response?.data?.message || 'Error al asignar la indumentaria')
        }
    }

    /**
     * Cambiar talla de una indumentaria
     */
    async function cambiarTalla(data) {
        const params = {
            base_id: props.base_id,
            lista_id: props.lista_id,
            ...data
        }

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.indumentaria_base.update'),
                params
            )
            toast.success(res.data.message || 'Talla cambiada correctamente')
            await refreshBase()
            showCambiarTallaModal.value = false
        } catch (error) {
            console.error('Error changing talla:', error)
            toast.error(error.response?.data?.message || 'Error al cambiar la talla')
        }
    }

    return {
        showCambiarTallaModal,
        addIndumentaria,
        cambiarTalla,
    }
}
